import React, { useState } from 'react';
import './DailyHoroscope.css';



const RASHIS = [
  { id: 'mesh',      name: 'Mesh',      en: 'Aries',       element: 'Fire'  },
  { id: 'vrishabha', name: 'Vrishabha', en: 'Taurus',      element: 'Earth' },
  { id: 'mithun',    name: 'Mithun',    en: 'Gemini',      element: 'Air'   },
  { id: 'karka',     name: 'Karka',     en: 'Cancer',      element: 'Water' },
  { id: 'simha',     name: 'Simha',     en: 'Leo',         element: 'Fire'  },
  { id: 'kanya',     name: 'Kanya',     en: 'Virgo',       element: 'Earth' },
  { id: 'tula',      name: 'Tula',      en: 'Libra',       element: 'Air'   },
  { id: 'vrishchik', name: 'Vrishchik', en: 'Scorpio',     element: 'Water' },
  { id: 'dhanu',     name: 'Dhanu',     en: 'Sagittarius', element: 'Fire'  },
  { id: 'makar',     name: 'Makar',     en: 'Capricorn',   element: 'Earth' },
  { id: 'kumbha',    name: 'Kumbha',    en: 'Aquarius',    element: 'Air'   },
  { id: 'meen',      name: 'Meen',      en: 'Pisces',      element: 'Water' },
];

const PREDICTIONS = {
  mesh:      { today: 'Mars energises your ambitions today. A long-awaited opportunity arrives — act decisively. Lucky colour: Red. Lucky number: 9.', weekly: 'This week sees career momentum building. Mid-week brings a financial gain. Avoid impulsive decisions on Thursday.' },
  vrishabha: { today: 'Venus blesses relationships and creativity. A heartfelt conversation strengthens bonds. Lucky colour: Green. Lucky number: 6.', weekly: 'Stability in finances. Focus on health mid-week. Weekend brings romantic opportunities.' },
  mithun:    { today: 'Mercury sharpens your communication. A new idea lands well professionally. Lucky colour: Yellow. Lucky number: 5.', weekly: 'Social connections open doors. A sibling or close friend offers valuable advice Thursday.' },
  karka:     { today: 'Moon heightens your intuition. Trust your gut in all matters today. Lucky colour: White. Lucky number: 2.', weekly: 'Home and family require attention early week. Career stabilises by Friday.' },
  simha:     { today: 'Sun radiates confidence through you. Leadership is your strength today. Lucky colour: Gold. Lucky number: 1.', weekly: 'Recognition arrives mid-week. A creative project gets the green light by Friday.' },
  kanya:     { today: 'Mercury brings precision and clarity. Analytical tasks yield great results. Lucky colour: Brown. Lucky number: 3.', weekly: 'Health focus is essential. Professional progress is steady and rewarding this week.' },
  tula:      { today: 'Venus brings harmony and balance. Relationships thrive with kind words. Lucky colour: Pink. Lucky number: 6.', weekly: 'Partnership decisions require care. Financial planning mid-week brings clarity.' },
  vrishchik: { today: 'Mars fuels your determination. Overcome a persistent obstacle with focused will. Lucky colour: Maroon. Lucky number: 8.', weekly: 'Intense week with transformation opportunities. Avoid power struggles Thursday–Friday.' },
  dhanu:     { today: 'Jupiter expands your horizons. A journey or learning opportunity presents itself. Lucky colour: Orange. Lucky number: 3.', weekly: 'Spiritual insights deepen mid-week. Travel plans solidify over the weekend.' },
  makar:     { today: 'Saturn rewards consistent effort. Recognition for hard work is on its way. Lucky colour: Blue. Lucky number: 8.', weekly: 'Career is your primary focus. A senior figure offers guidance Thursday.' },
  kumbha:    { today: 'Rahu stimulates innovation. An unconventional idea solves a pressing problem. Lucky colour: Violet. Lucky number: 4.', weekly: 'Community and networking are highlighted. A surprise contact mid-week brings opportunity.' },
  meen:      { today: 'Jupiter and Neptune deepen spirituality. Meditation and reflection bring clarity. Lucky colour: Sea green. Lucky number: 7.', weekly: 'Creative and spiritual energy peaks Tuesday. Financial caution advised Thursday.' },
};

const ICON_PROPS = {
  xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 40 40',
  width: '36', height: '36', fill: 'none',
  stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round',
};

const RashiIcon = ({ id, size = 36 }) => {
  const p = { ...ICON_PROPS, width: size, height: size };
  switch (id) {
    case 'mesh':      return <svg {...p}><path d="M20 32 L20 21 Q20 10 11 8"/><path d="M20 21 Q20 10 29 8"/></svg>;
    case 'vrishabha': return <svg {...p}><circle cx="20" cy="25" r="9"/><path d="M13 20 Q13 8 20 8 Q27 8 27 20"/></svg>;
    case 'mithun':    return <svg {...p}><line x1="13" y1="8" x2="13" y2="32"/><line x1="27" y1="8" x2="27" y2="32"/><line x1="13" y1="8" x2="27" y2="8"/><line x1="13" y1="32" x2="27" y2="32"/></svg>;
    case 'karka':
      return <svg {...p}><path d="M14 20 Q14 12 20 12 Q26 12 26 20"/><circle cx="27" cy="20" r="2.5" fill="#D4AF37" stroke="none"/><path d="M26 20 Q26 28 20 28 Q14 28 14 20"/><circle cx="13" cy="20" r="2.5" fill="#D4AF37" stroke="none"/></svg>;
    case 'simha':     return <svg {...p}><circle cx="17" cy="17" r="8"/><path d="M25 18 Q32 17 33 24 Q34 31 27 33"/></svg>;
    case 'kanya':     return <svg {...p}><path d="M8 30 L8 14 L16 24 L24 14 L24 30 Q24 36 28 36 Q32 36 32 30 Q32 24 28 24"/></svg>;
    case 'tula':
      return <svg {...p}><line x1="8" y1="32" x2="32" y2="32"/><line x1="20" y1="12" x2="20" y2="32"/><path d="M10 25 Q14 17 18 25"/><line x1="10" y1="25" x2="18" y2="25"/><path d="M22 25 Q26 17 30 25"/><line x1="22" y1="25" x2="30" y2="25"/></svg>;
    case 'vrishchik':
      return <svg {...p}><path d="M8 14 L8 28 L16 21 L24 28 L24 14"/><line x1="24" y1="21" x2="32" y2="21"/><path d="M29 18 L32 21 L29 24"/></svg>;
    case 'dhanu':
      return <svg {...p}><line x1="10" y1="30" x2="30" y2="10"/><path d="M22 10 L30 10 L30 18"/><line x1="13" y1="21" x2="27" y2="21"/></svg>;
    case 'makar':     return <svg {...p}><path d="M8 10 Q8 22 16 28 Q24 34 32 28"/><path d="M8 10 L17 22 Q20 28 23 23 Q26 17 22 13 Q18 9 22 7"/></svg>;
    case 'kumbha':
      return <svg {...p}><path d="M8 16 Q12 11 16 16 Q20 21 24 16 Q28 11 32 16"/><path d="M8 26 Q12 21 16 26 Q20 31 24 26 Q28 21 32 26"/></svg>;
    case 'meen':
      return <svg {...p}><path d="M10 20 Q10 8 20 8 Q30 8 30 20"/><path d="M10 20 Q10 32 20 32 Q30 32 30 20"/><line x1="10" y1="20" x2="30" y2="20"/></svg>;
    default: return null;
  }
};

const DailyHoroscope = () => {
  const [selected, setSelected] = useState(null);
  const [tab, setTab] = useState('today');

  const handleRashi = (rashi) => {
    setSelected(selected?.id === rashi.id ? null : rashi);
    setTab('today');
  };

  const pred = selected ? PREDICTIONS[selected.id] : null;

  return (
    <section className="horoscope" id="daily-horoscope" aria-label="Free daily horoscope">
      <div className="horoscope__inner">
        <div className="horoscope__header">
          <p className="section-eyebrow">Free Every Day</p>
          <h2 className="section-title">Daily Horoscope</h2>
          <p className="section-sub">Select your Rashi to reveal today's cosmic guidance</p>
          <div className="gold-divider" />
        </div>

        <div className="rashi-grid" role="list">
          {RASHIS.map((r) => (
            <button key={r.id} role="listitem"
              className={`rashi-tile${selected?.id === r.id ? ' rashi-tile--active' : ''}`}
              onClick={() => handleRashi(r)} aria-pressed={selected?.id === r.id}
              aria-label={`Select ${r.name} (${r.en})`}>
              <div className="rashi-tile__icon" aria-hidden="true">
                <RashiIcon id={r.id} size={34} />
              </div>
              <span className="rashi-tile__name">{r.name}</span>
              <span className="rashi-tile__en">{r.en}</span>
            </button>
          ))}
        </div>

        {selected && pred && (
          <div className="pred-panel" role="region" aria-label={`${selected.name} prediction`}>
            <div className="pred-panel__top">
              <div className="pred-panel__icon" aria-hidden="true">
                <RashiIcon id={selected.id} size={48} />
              </div>
              <div>
                <h3 className="pred-panel__rashi">{selected.name} — {selected.en}</h3>
                <span className="pred-panel__element">{selected.element} Sign</span>
              </div>
              <div className="pred-panel__tabs">
                <button className={`pred-tab${tab === 'today'  ? ' pred-tab--active' : ''}`}
                  onClick={() => setTab('today')}>Today</button>
                <button className={`pred-tab${tab === 'weekly' ? ' pred-tab--active' : ''}`}
                  onClick={() => setTab('weekly')}>This Week</button>
              </div>
            </div>
            <div className="gold-divider" />
            <p className="pred-panel__text">{tab === 'today' ? pred.today : pred.weekly}</p>
            <p className="pred-panel__note">
              ✦ Full detailed reading available with a personal consultation —{' '}
              <a href="/chat">Chat for Reading</a>
            </p>
          </div>
        )}

        <div className="weekly-section">
          <h3 className="weekly-section__title">Weekly Rashi Phal</h3>
          <p className="weekly-section__sub">Select any rashi above and switch to "This Week" for your weekly forecast.</p>
          <div className="weekly-highlights">
            {[
              { label: 'Favourable Rashis', value: 'Simha, Dhanu, Mesh'  },
              { label: 'Caution Needed',    value: 'Vrishchik, Karka'    },
              { label: 'Best Day',          value: 'Wednesday'           },
            ].map((h) => (
              <div key={h.label} className="weekly-pill">
                <span className="weekly-pill__label">{h.label}</span>
                <span className="weekly-pill__value">{h.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DailyHoroscope;
